// Just pass through. The rest is handled by paper.js itself.
// See `requireName` in paper.js/src/node/self.js
module.exports = require('paper');